module.exports = __webpack_public_path__ + "static/media/ils_covid_success_fisdom.6c057056.svg";